import * as React from 'react';
import { MessageBubble } from './message-bubble.component';
import { EventIndicator } from './event-indicator.component';
import type { ChatHistoryMessageProps } from './chat-history-message.types';

export type { ChatHistoryMessageProps };

export const ChatHistoryMessage = ({
  eventType,
  senderName,
  senderAvatar,
  timestamp,
  content,
  children,
  eventText,
  onNextClick,
  onPreviousClick,
}: ChatHistoryMessageProps): React.ReactElement | null => {
  switch (eventType) {
    case 'message':
      return (
        <MessageBubble
          senderName={senderName}
          senderAvatar={senderAvatar}
          timestamp={timestamp}
          content={content}
          onNextClick={onNextClick}
          onPreviousClick={onPreviousClick}
        >
          {children}
        </MessageBubble>
      );

    case 'system_event':
    case 'waiting_room':
      return <EventIndicator eventText={eventText} />;

    default:
      return null;
  }
};
